module.exports = __webpack_public_path__ + "img/复活节兔子灯-1.f916e05e.jpg";